import { make } from './InputSearch.gen'

type InputSearchProps = React.ComponentProps<typeof make>

const InputSearch = make as React.FunctionComponent<InputSearchProps>

export { InputSearch, type InputSearchProps }
